import Cookies, { CookieAttributes } from 'js-cookie';

export const getCookie = (name: string) => Cookies.get(name);

export const setCookie = (name: string, value: string, options?: CookieAttributes) => {
  Cookies.set(name, value, options);
};
